<app-dashboard-header></app-dashboard-header>

<div class="resources-content">
  <h1 class="page-title">Resources</h1>
  
  <div class="type-selector-container">
    <mat-tab-group
      class="resource-type-tab-group"
      [selectedIndex]="selectedResourceTypeTabIndex"
      (selectedIndexChange)="onResourceTypeTabChange($event)"
      animationDuration="0ms"
    >
      <mat-tab *ngFor="let type of resourceTypes" [label]="type.name"></mat-tab>
    </mat-tab-group>
  </div>
  
  <mat-card>
    <div class="card-header">
      <h2>Manage Resources</h2>
      <div class="header-actions">
        <button *ngIf="resources.length > 0 && !hasExternalResources()" mat-flat-button class="action-button accent" (click)="deleteAllAvailability()">
          <mat-icon>delete_sweep</mat-icon>
          Delete All Availability
        </button>
        <button *ngIf="!hasExternalResources()" mat-flat-button class="action-button accent" (click)="openAddDialog()">
          <mat-icon>add</mat-icon>
          Add Resource
        </button>
      </div>
    </div>

      <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="40"></mat-progress-spinner>

      <div *ngIf="error" class="error-message">
        {{ error }}
      </div>

      <div *ngIf="!loading && resources.length > 0" class="table-container">
        <table mat-table [dataSource]="resources">

          <!-- ID Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let resource">{{ resource.id }}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let resource">
              {{ resource.name }}
            </td>
          </ng-container>

          <!-- Capacity Column -->
          <ng-container matColumnDef="capacity">
            <th mat-header-cell *matHeaderCellDef>Capacity</th>
            <td mat-cell *matCellDef="let resource">
              {{ resource.capacity || 1 }}
            </td>
          </ng-container>

          <!-- Availability Column -->
          <ng-container matColumnDef="availability">
            <th mat-header-cell *matHeaderCellDef>Availability</th>
            <td mat-cell *matCellDef="let resource">
              <app-availability-blocks
                [availability]="resource.availability || []"
                [compact]="true"
                [maxBlocks]="3">
              </app-availability-blocks>
            </td>
          </ng-container>
          
         

          <!-- Dynamic Attribute Columns -->
          <ng-container *ngFor="let attribute of getResourceTypeAttributes()" [matColumnDef]="'attr_' + attribute.id">
            <th mat-header-cell *matHeaderCellDef>
              <div style="display: flex; flex-direction: column;">
                <span>{{ attribute.name }}</span>
                <span style="font-size: 0.75em; color: #888; opacity: 0.7;">{{ attribute.slug || '-' }}</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let resource" (click)="$event.stopPropagation()">
              <div class="attribute-cell">
                <!-- Checkbox attribute (toggle) -->
                <ng-container *ngIf="attribute.type === 'checkbox'">
                  <mat-slide-toggle
                    [checked]="getAttributeValue(resource, attribute.id) === 'true'"
                    [disabled]="!!attribute.external || isSaving(resource.id, attribute.id)"
                    (change)="onAttributeChange(resource, attribute, $event.checked ? 'true' : 'false')">
                  </mat-slide-toggle>
                  <mat-spinner *ngIf="isSaving(resource.id, attribute.id)" diameter="16" class="saving-spinner"></mat-spinner>
                </ng-container>

                <!-- Select attribute (dropdown) -->
                <ng-container *ngIf="attribute.type === 'select'">
                  <mat-form-field appearance="outline" class="inline-form-field">
                    <mat-select
                      [value]="getAttributeValue(resource, attribute.id)"
                      [disabled]="!!attribute.external || isSaving(resource.id, attribute.id)"
                      (selectionChange)="onAttributeChange(resource, attribute, $event.value)">
                      <mat-option value="">-</mat-option>
                      <mat-option *ngFor="let opt of getSelectOptions(attribute)" [value]="opt.slug">
                        {{ opt.display }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-spinner *ngIf="isSaving(resource.id, attribute.id)" diameter="16" class="saving-spinner"></mat-spinner>
                </ng-container>

                <!-- Number attribute (click to edit) -->
                <ng-container *ngIf="attribute.type === 'number'">
                  <span *ngIf="!isEditing(resource.id, attribute.id)"
                        class="editable-cell number-cell"
                        [class.disabled]="!!attribute.external"
                        (click)="!attribute.external && startEditing(resource.id, attribute.id, $event)">
                    {{ getAttributeValue(resource, attribute.id) || '-' }}
                    <mat-icon class="edit-icon" *ngIf="!attribute.external">edit</mat-icon>
                  </span>
                  <div *ngIf="isEditing(resource.id, attribute.id)" class="inline-edit-container">
                    <mat-form-field appearance="outline" class="inline-form-field">
                      <input matInput
                        type="number"
                        [value]="getAttributeValue(resource, attribute.id)"
                        (blur)="onTextNumberBlur(resource, attribute, $any($event.target).value)"
                        (keydown)="onTextNumberKeydown($event, resource, attribute)">
                    </mat-form-field>
                    <mat-icon class="cancel-icon" (mousedown)="cancelEditing($event)">close</mat-icon>
                  </div>
                  <mat-spinner *ngIf="isSaving(resource.id, attribute.id)" diameter="16" class="saving-spinner"></mat-spinner>
                </ng-container>

                <!-- Text attribute (click to edit) -->
                <ng-container *ngIf="attribute.type !== 'checkbox' && attribute.type !== 'number' && attribute.type !== 'select'">
                  <span *ngIf="!isEditing(resource.id, attribute.id)"
                        class="editable-cell"
                        [class.disabled]="!!attribute.external"
                        (click)="!attribute.external && startEditing(resource.id, attribute.id, $event)">
                    {{ getAttributeValue(resource, attribute.id) || '-' }}
                    <mat-icon class="edit-icon" *ngIf="!attribute.external">edit</mat-icon>
                  </span>
                  <div *ngIf="isEditing(resource.id, attribute.id)" class="inline-edit-container">
                    <mat-form-field appearance="outline" class="inline-form-field">
                      <input matInput
                        type="text"
                        [value]="getAttributeValue(resource, attribute.id)"
                        (blur)="onTextNumberBlur(resource, attribute, $any($event.target).value)"
                        (keydown)="onTextNumberKeydown($event, resource, attribute)">
                    </mat-form-field>
                    <mat-icon class="cancel-icon" (mousedown)="cancelEditing($event)">close</mat-icon>
                  </div>
                  <mat-spinner *ngIf="isSaving(resource.id, attribute.id)" diameter="16" class="saving-spinner"></mat-spinner>
                </ng-container>
              </div>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef style="width: 260px;">Actions</th>
            <td mat-cell *matCellDef="let resource">
              <button mat-icon-button color="primary"
                      matTooltip="Edit"
                      (click)="$event.stopPropagation(); openEditDialog(resource)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="accent"
                      [matTooltip]="resource.external ? 'Cannot edit availability: Managed externally via SSO' : 'Manage Availability'"
                      [disabled]="!!resource.external"
                      (click)="$event.stopPropagation(); manageAvailability(resource)">
                <mat-icon>schedule</mat-icon>
              </button>
              <button mat-icon-button
                      [matTooltip]="resource.external ? 'Cannot copy: Managed externally via SSO' : 'Copy Resource Data'"
                      [disabled]="!!resource.external"
                      (click)="$event.stopPropagation(); openCopyAvailabilityDialog(resource)">
                <mat-icon>schedule_send</mat-icon>
              </button>
              <button mat-icon-button
                      [matTooltip]="resource.external ? 'Cannot copy: Managed externally via SSO' : 'Copy Resource'"
                      [disabled]="!!resource.external"
                      (click)="$event.stopPropagation(); openCopyResourceDialog(resource)">
                <mat-icon>content_copy</mat-icon>
              </button>
              <button mat-icon-button color="warn"
                      [matTooltip]="resource.external ? 'Cannot delete: Managed externally via SSO' : 'Delete'"
                      [disabled]="!!resource.external"
                      (click)="$event.stopPropagation(); deleteResource(resource)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
              (click)="openEditDialog(row)"
              class="clickable-row"
              [class.external-row]="row.external"></tr>
        </table>
      </div>
      <div *ngIf="!loading && resources.length === 0" class="no-resources">
        <mat-icon>info</mat-icon>
        <p>No resources found. Select a resource type and click the "Add Resource" button to create your first resource.</p>
      </div>
  </mat-card>
</div>

<app-dashboard-footer></app-dashboard-footer>
